import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    container: {
        display: 'flex',
        marginTop: '30px',
        alignItems: 'center'
    },

    imgBusqueda: {
        width: '40px',
        height: '40px',
    },

    texto: {
        marginLeft: '12px',
        fontWeight: '400',
        fontSize: '20px',
        lineHeight: '23px',
        letterSpacing: '-0.04em',
        color : '#535353',
    },
});
